<template>
	<div>
		<v-expansion-panels v-model="panel" flat accordion>
			<ExpansionPanel :title="'Basics'">
				<SettingSwitch
					:title="'Label'"
					:placeholder="'Type your title here'"
					:switchValue.sync="titleEnabled"
					:textFieldValue.sync="titleValue"
				/>
				<SettingSwitch
					:title="'Description'"
					:placeholder="'Type your description here'"
					:switchValue.sync="descriptionEnabled"
					:textFieldValue.sync="descriptionValue"
				/>
				<SettingSwitch :title="'Let user choose'" :switchValue.sync="userSelectionEnabled" />
				<SettingSwitch :title="'Required'" v-if="userSelectionEnabled" :switchValue.sync="requiredEnabled" />
			</ExpansionPanel>
		</v-expansion-panels>

		<OptionWrapper class="text-left field-settings mt-5 field-setting-section" label="Choose data source">
			<StepSelector :stepId.sync="stepId" />
		</OptionWrapper>
	</div>
</template>

<script>
import StepSelector from './common/StepSelector';
import ParamsService from '@/utils/ParamsService';
import SettingSwitch from './WidgetSettings/SettingSwitch';
import ExpansionPanel from './WidgetSettings/ExpansionPanel';
import OptionWrapper from '../FieldSettings/FieldOptions/OptionWrapper';
import FieldSettingsMixin from '@/components/BlockEditorWidget/FieldSettings/FieldSettingsMixin';

export default {
	name: 'GalleryFieldSettings',
	mixins: [FieldSettingsMixin],
	components: {
		StepSelector,
		OptionWrapper,
		SettingSwitch,
		ExpansionPanel,
	},
	computed: {
		stepId: {
			get() {
				return ParamsService.extractNodeUUIDFromValue(this.localField.metadata.options.step_id.value);
			},
			set(value) {
				this.setLocalFieldKey('metadata.options.step_id', { value: `{{${value}__*}}` });
			},
		},
		userSelectionEnabled: {
			get() {
				return this.localField.metadata.options.user_selection.enabled;
			},
			set(value) {
				this.setLocalFieldKey('metadata.options.user_selection.enabled', value);
			},
		},
	},
};
</script>
